import { Skeleton } from '../../../../feedback/Skeleton';
import { Box } from '../../../../layout/Box';
import { Flex } from '../../../../layout/Flex';
import { BUSINESS_COVER_RATIO } from '../../constants';
import { BusinessCardContent, BusinessCardRoot, BusinessCardRow, Properties } from '../../styles';
import type { BusinessCardSkeletonProps } from './types';

const PropertySkeleton = () => (
    <Flex
        direction={{ xs: 'row', sm: 'column' }}
        alignItems={{ sm: 'flex-end' }}
        spacing={{ xs: 0.5, sm: 0 }}
    >
        <Skeleton variant="text" width={60} height={20} />
        <Skeleton variant="text" width={100} height={20} />
    </Flex>
);

export const BusinessCardSkeleton = (props: BusinessCardSkeletonProps) => (
    <BusinessCardRoot {...props}>
        <Skeleton variant="rect" ratio={BUSINESS_COVER_RATIO} />
        <BusinessCardContent>
            <Box pb={1}>
                <BusinessCardRow
                    spacing={{ xs: 1, sm: 2 }}
                    direction={{ xs: 'column', sm: 'row' }}
                    alignItems={{ sm: 'center' }}
                    justifyContent={{ sm: 'space-between' }}
                >
                    <Flex direction="row" alignItems="center" spacing={2}>
                        <Skeleton
                            variant="circular"
                            width={{ xs: 100, sm: 108 }}
                            height={{ xs: 100, sm: 108 }}
                            mt={-3.5}
                        />
                        <Box>
                            <Skeleton variant="text" width={120} height={26} />
                            <Skeleton variant="text" width={100} height={14} />
                        </Box>
                    </Flex>

                    <Properties>
                        <PropertySkeleton />
                        <PropertySkeleton />
                    </Properties>
                </BusinessCardRow>
                <BusinessCardRow spacing={1}>
                    <Skeleton variant="text" width="100%" height={20} />
                    <Skeleton variant="text" width="30%" height={20} />
                </BusinessCardRow>
                <BusinessCardRow direction="row" spacing={1}>
                    <Skeleton variant="rect" width="50%" height={32} borderRadius="999px" />
                    <Skeleton variant="rect" width="50%" height={32} borderRadius="999px" />
                </BusinessCardRow>
                <BusinessCardRow direction="row" spacing={1}>
                    <Skeleton variant="rect" width="100%" height={32} borderRadius="999px" />
                </BusinessCardRow>
            </Box>
        </BusinessCardContent>
    </BusinessCardRoot>
);
